import ethereum from 'decentralized/ethereum.js';
import GetSequences from 'search/GetSequences.js';
import {getProjects} from 'components/sequences2/getProjects.js';

export const fetchSequences = async (starred, favorited, searchTerm, searchTag, guildId, personSelected) => {
    return await getProjects(searchTerm, undefined, starred, favorited, searchTag, false, guildId, personSelected);
};
